// extracted by mini-css-extract-plugin
export default {"form":"form_form__xuG5P","sm":"form_sm__KNHE5","input":"form_input__1536Y","inputWhite":"form_inputWhite__hTzU6","result":"form_result__VPBKA"};